export default __webpack_public_path__ + "static/media/iread_22_6.c390aba9.jpg";